import React, { useState, useEffect } from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { useDebounce } from 'Src/hooks/use-debounce/useDebounce';
import { getResultItem as formatAutocompleteResults } from 'Store/utils/autocompleteItemHelper';
import { suggest as fetchAutocompleteResults } from 'Utils/pertimm-client';
export function useAutocomplete(keywords: string = '') {
  const appContext = useAppContext();
  const [autocompleteQuery, setAutocompleteQuery] = useState<string>(keywords);
  const [autocompleteResults, setAutocompleteResults] = useState<Array<any>>([]);
  const [debouncedAutocompleteQuery] = useDebounce([autocompleteQuery], 300);
  // This effect is used to fetch autocomplete suggestions when the query changes (with a 300ms debounce)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { answers = [] } = await fetchAutocompleteResults({
          criteria: {
            keywords: debouncedAutocompleteQuery,
          },
          appContext,
        });
        const results = answers
          .map(formatAutocompleteResults)
          .sort(
            ({ displayPosition: displayPositionA }, { displayPosition: displayPositionB }) =>
              displayPositionA - displayPositionB,
          );
        setAutocompleteResults(results);
      } catch (error) {
        setAutocompleteResults([]);
      }
    };

    if (debouncedAutocompleteQuery) {
      fetchData();
    } else {
      setAutocompleteResults([]);
    }
  }, [debouncedAutocompleteQuery]);
  return {
    autocompleteQuery,
    setAutocompleteQuery,
    autocompleteResults,
    setAutocompleteResults,
  };
}
